// extracted by mini-css-extract-plugin
export default {"container":"events_container__xZZEF","slide":"events_slide__3niYU","empty":"events_empty__3-K2E"};